import React, { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import type { rowsAdditionalContentRenderer_nativeIssueTable$key } from '@atlassian/jira-relay/src/__generated__/rowsAdditionalContentRenderer_nativeIssueTable.graphql';
import { useCustomComponents } from '../../../controllers/custom-components/index.tsx';

export type RowsAdditionalContentRendererProps = {
	depth: number;
	groupId?: string;
	issues: rowsAdditionalContentRenderer_nativeIssueTable$key;
};

export const RowsAdditionalContentRenderer: FC<RowsAdditionalContentRendererProps> = ({
	depth,
	groupId,
	issues,
}) => {
	const { RowsAdditionalContent } = useCustomComponents();

	const issuesData = useFragment(
		graphql`
			fragment rowsAdditionalContentRenderer_nativeIssueTable on JiraIssueConnection
			@argumentDefinitions(isTimelineEnabled: { type: "Boolean!" }) {
				# eslint-disable-next-line @atlassian/relay/must-colocate-fragment-spreads
				...timelineRowsContent_issueTableTimeline @include(if: $isTimelineEnabled)
			}
		`,
		issues,
	);

	return (
		RowsAdditionalContent && (
			<RowsAdditionalContent depth={depth} groupId={groupId} issues={issuesData} />
		)
	);
};
